import { render } from "./Footer.vue?vue&type=template&id=6c2e63ea&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=6c2e63ea&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6c2e63ea"

export default script